module.exports = __webpack_public_path__ + "contents/index/video/eyecatch.mp4?d3a57a5677896b1eccd9e44a02195bc4";